module.exports = __webpack_public_path__ + "img/155.38128ae4.jpg";